<div class = "position" [ngClass]="{'background':backGround}">    
    <ng-content></ng-content>
</div>